import { ButtonSelectorOption } from '@ui/button-selector';

export const TABLET_TYPE_OPTIONS: ButtonSelectorOption[] = [
    { value: 'buy', label: 'patient.modal.replace-kit.tab-buy' },
    { value: 'rent', label: 'patient.modal.replace-kit.tab-rent' },
    { value: 'free', label: 'patient.modal.replace-kit.tab-free' },
];

export const ARMBAND_TYPE_OPTIONS: ButtonSelectorOption[] = [
    { value: 'classic', label: 'patient.modal.replace-kit.armband-classic' },
    { value: 'xl', label: 'patient.modal.replace-kit.armband-xl' },
];
